// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qy-6";
export var imgContainer = "_qy-3";
export var menuIcon = "_qy-5";
export var pillWrapper = "_qy-2";
export var pillsContainer = "_qy-1";
export var subscriptionCard = "_qy-0";
export var subscriptionLogo = "_qy-4";